function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

module.exports = _nonIterableSpread;


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/helpers/nonIterableSpread.js
// module id = 69
// module chunks = 0